import { connect } from "react-redux";
import { requestGetInvoicesByClaimId } from "../../../../store/data/thunks";
import { State } from "../../../../store/state";

import Invoices from "./Invoices";

const mapStateToProps = (state: State) => ({
  invoices: state.data.invoices
});

const mapDispatchToProps = {
  requestGetInvoicesByClaimId
};

const InvoicesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Invoices);

export default InvoicesContainer;
